import type { ModelBranch } from '@app/api/Branches';

export const adaptBranchesToRedux = (data: ModelBranch, flag?: string) => {
  const {
    Address,
    City,
    CountUsers,
    CreateUserId,
    Id,
    IsDeleted,
    Name,
    OrganizationName,
    TimeCreated,
    Timezone,
    ChainId,
    LegalEntity,
  } = data;

  const result =
    flag === 'toRegistry'
      ? {
          address: Address || '',
          city: City || '',
          countUsers: CountUsers,
          createUserId: CreateUserId,
          id: Id,
          key: Id,
          status: IsDeleted ? 'В архиве' : '',
          isDeleted: IsDeleted,
          name: Name,
          organizationName: OrganizationName || null,
          timeCreated: TimeCreated,
          timezone: Timezone,
          chainId: ChainId,
          legalEntity: LegalEntity,
        }
      : {
          address: Address,
          status: '',
          key: Id,
          city: City,
          countUsers: CountUsers,
          createUserId: CreateUserId,
          id: Id,
          isDeleted: IsDeleted,
          name: Name,
          organizationName: OrganizationName || null,
          timeCreated: TimeCreated,
          timezone: Timezone,
          chainId: ChainId,
          legalEntity: LegalEntity,
        };

  return result;
};
